module.exports = __webpack_public_path__ + "img/Desk Stationeryd00.2c74f6e1.jpg";